import React from 'react';
import { CTAButton, Section, Countdown } from './Shared';
export function Hero() {
  return <div className="relative overflow-hidden bg-cream min-h-[90vh] flex items-center pt-20 pb-12 md:pt-24 md:pb-20" data-id="element-96">
      {/* Background Image — soft maternal background, blurred and positioned bottom-right */}
      <div className="absolute inset-0 z-0 opacity-20" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/i5HANysQwSgA15ys83hoxU/ChatGPT_Image_9_may_2026,_10_04_59_p.m..png")',
      backgroundPosition: 'right bottom',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      filter: 'blur(8px)',
      transform: 'scale(1.05)'
    }} data-id="element-97"></div>

      {/* Warm cream overlay for legibility */}
      <div className="absolute inset-0 z-0 bg-cream/60" data-id="element-98"></div>

      {/* Soft directional gradient — keeps text area extra clean */}
      <div className="absolute inset-0 z-0 bg-gradient-to-b md:bg-gradient-to-r from-cream/90 via-cream/70 to-cream/40" data-id="element-99"></div>

      <Section className="relative z-10 w-full !py-0" data-id="element-100">
        <div className="grid md:grid-cols-2 gap-12 md:gap-8 items-center" data-id="element-101">
          {/* Left Content */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-102">
            <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl text-charcoal font-medium leading-[1.15] mb-6 max-w-2xl" data-id="element-103">
              ¿Sabés qué necesita tu bebé para{' '}
              <span className="font-script text-sage-dark text-5xl md:text-6xl lg:text-7xl" data-id="element-104">
                desarrollarse bien
              </span>{' '}
              en cada etapa?
            </h1>

            <p className="text-lg md:text-xl text-charcoal-light mb-4 max-w-lg leading-relaxed" data-id="element-105">
              Descubrí las actividades exactas para su edad y acompañá su
              crecimiento desde casa.
            </p>

            <p className="text-sm md:text-base text-charcoal-light/80 mb-7 max-w-lg leading-relaxed italic" data-id="element-106">
              Estimulación temprana simple, amorosa y adaptada a cada etapa —
              desde recién nacido hasta los 3 años.
            </p>

            <ul className="text-left space-y-2 mb-6 text-charcoal font-medium" data-id="element-107">
              <li className="flex items-center gap-2" data-id="element-108">
                <span className="text-cta" data-id="element-109">✔</span> Actividades según cada edad
              </li>
              <li className="flex items-center gap-2" data-id="element-110">
                <span className="text-cta" data-id="element-111">✔</span> Desarrollo motriz,
                cognitivo y emocional
              </li>
              <li className="flex items-center gap-2" data-id="element-112">
                <span className="text-cta" data-id="element-113">✔</span> Solo 10 minutos al día
              </li>
              <li className="flex items-center gap-2" data-id="element-114">
                <span className="text-cta" data-id="element-115">✔</span> Sin materiales caros
              </li>
            </ul>

            <div className="flex flex-wrap gap-2 mb-8" data-id="element-116">
              <span className="bg-sage-light/40 border border-sage/30 text-charcoal text-sm font-medium px-4 py-2 rounded-full" data-id="element-117">
                ✨ Más conexión, menos presión
              </span>
              <span className="bg-gold-light/50 border border-gold/30 text-charcoal text-sm font-medium px-4 py-2 rounded-full" data-id="element-118">
                🧠 Estimulá su desarrollo de forma natural
              </span>
            </div>

            <div className="w-full md:w-auto flex flex-col items-center md:items-start" data-id="element-119">
              <Countdown data-id="element-120" />
              <CTAButton className="mt-2" data-id="element-121">QUIERO EMPEZAR HOY</CTAButton>
              <p className="mt-3 text-xs md:text-sm text-charcoal-light/80 text-center md:text-left" data-id="element-122">
                Guía completa + 5 bonos incluidos · $19.990 ARS · 3 cuotas sin
                interés
              </p>
              <p className="mt-4 text-sm text-charcoal-light font-medium" data-id="element-123">
                ⭐⭐⭐⭐⭐ Más de 1.000 mamás ya lo están usando
              </p>
            </div>
          </div>

          {/* Right Content - Transparent Product Mockup */}
          <div className="relative flex justify-center md:justify-end" data-id="element-124">
            <img src="https://cdn.magicpatterns.com/uploads/sRG1JwkjEXNBVG7ha77xWp/hacer_mas_profesional_este_mockup_202605091959.jpg" alt="Estimulación Temprana Inteligente Desde Casa" className="w-full max-w-lg md:max-w-xl h-auto object-contain drop-shadow-[0_12px_40px_rgba(0,0,0,0.15)] rounded-2xl transform md:translate-x-4 scale-105 md:scale-110" data-id="element-125" />
          </div>
        </div>
      </Section>
    </div>;
}